import { type AxiosRequestConfig } from 'axios'

const confirmEventApplications = (id: string): AxiosRequestConfig => {
  return {
    method: 'PUT',
    url: '/events/applications',
    params: {
      id,
    }
  }
}

export { confirmEventApplications }
